// extracted by mini-css-extract-plugin
export default {"title":"_6kfav","titleFacelift":"ujmM0"};